<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('products')">Prodotti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>

    <trashed-message v-if="product.deleted_at" class="mb-6" @restore="restore">
      Questo prodotto è stato cancellato.
    </trashed-message>
    <!-- Mostra il messaggio di avviso se presente -->
    <div v-if="warningMessage" class="bg-yellow-100 text-yellow-800 p-4 rounded mb-6">
      {{ warningMessage }}
      <button @click.prevent="confirmUpdate" class="ml-4 bg-yellow-500 text-white px-4 py-2 rounded">
        Conferma Aggiornamento
      </button>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-for="field in orderedFields" :key="field.key" v-model="form[field.key]"
            :error="form.errors[field.key]" class="pr-6 pb-8 w-full lg:w-1/2" :label="field.label" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!product.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy">Elimina Prodotto</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            Aggiorna Prodotto
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `Modifica Prodotto`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    product: Object,
    batches: Array,
  },
  remember: 'form',
  mounted() {
    // Leggi il messaggio di warning dal flash
    if (this.$page.props.flash.warning) {
      this.warningMessage = this.$page.props.flash.warning;
    }
  },
  data() {
    const fields = [
      { key: 'sku', label: 'SKU' },
      { key: 'prezzo_unitario', label: 'Prezzo unitario' },
      { key: 'name', label: 'Nome' },
      { key: 'ean_produttore', label: 'EAN produttore' },
      { key: 'cod_art_produttore', label: 'Codice articolo produttore' },
      { key: 'brand', label: 'Brand' },
      { key: 'categoria', label: 'Categoria' },
      { key: 'stagione', label: 'Stagione' },
      { key: 'genere', label: 'Genere' },
      { key: 'taglia', label: 'Taglia' },
      { key: 'colore', label: 'Colore' }
    ];

    let formValues = {
      sku: this.product.sku,
      prezzo_unitario: this.product.prezzo_unitario,
      name: this.product.name,
      ean_produttore: this.product.ean_produttore,
      cod_art_produttore: this.product.cod_art_produttore,
      brand: this.product.brand,
      categoria: this.product.categoria,
      stagione: this.product.stagione,
      genere: this.product.genere,
      taglia: this.product.taglia,
      colore: this.product.colore,
      force_update: false
    };

    // Riordina i campi mettendo prima quelli vuoti
    const orderedFields = fields.sort((a, b) => {
      return (formValues[a.key] ? 1 : 0) - (formValues[b.key] ? 1 : 0);
    });

    return {
      form: this.$inertia.form(formValues),
      orderedFields,
      warningMessage: null, // Per mostrare il messaggio di conflitto
      forceUpdate: false,   // Flag per forzare l'aggiornamento
    };
  },
  methods: {
    // Conferma l'aggiornamento impostando forceUpdate a true
    confirmUpdate() {
      this.forceUpdate = true;
      this.update();
    },
    update() {
      // Controlla frontend che i campi non siano vuoti
      if (!this.form.sku || !this.form.prezzo_unitario || !this.form.name) {
        return
      }

      // Imposta il campo force_update nel form
      this.form.force_update = this.forceUpdate;

      this.form.put(this.route('products.update', this.product.id), {
        onSuccess: (page) => {
          if (page.props.flash.warning) {
            this.warningMessage = page.props.flash.warning;
          } else if (page.props.flash.success) {
            this.$inertia.visit(this.route('products'));
          }
        },
        onError: (errors) => {
          console.log("Errore durante l'aggiornamento:", errors);
        }
      });
    },
    // Metodo per eliminare il prodotto
    destroy() {
      if (confirm('Vuoi eliminare questo prodotto?')) {
        this.$inertia.delete(this.route('products.destroy', this.product.id))
      }
    },

    // Metodo per ripristinare il prodotto
    restore() {
      if (confirm('Vuoi ripristinare questo prodotto?')) {
        this.$inertia.put(this.route('products.restore', this.product.id))
      }
    },
  },
}
</script>
